import { useForm } from 'react-hook-form';
import { Button, LoadingSpinner, Modal, RowContainer, toast } from '../../../common';
import { CreateGroup } from '../../../../services/Api/userGroups/useApiUserGroups';
import { useContext, useState } from 'react';
import { UserContext } from '../../../../contexts/user';

const NewGroupModal = ({ closeForm, onSuccess }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const { userDetails } = useContext(UserContext);

    const onSubmit = (data) => {
        setIsLoading(true);
        const postData = {
            name: data.groupName,
            email: userDetails.username,
        };

        CreateGroup(postData)
            .then((response) => {
                if (response && response?.status === 200) {
                    toast.success('Team Created');
                    onSuccess && onSuccess(response?.data[0]);
                } else {
                    toast.error();
                }
                setIsLoading(false);
                closeForm && closeForm();
            })
            .catch((err) => {
                console.error(err);
                toast.error();
                setIsLoading(false);
            });
    };

    const inputClasses =
        'w-full text-sm placeholder-secondary flex-grow transition-all outline-none p-3 bg-gray-50 rounded-lg focus:ring focus:border-blue-light active:ring active:border-blue-royal';

    return (
        <Modal title="Create New Team">
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="pb-3 w-full">
                        <input
                            placeholder="Team Name"
                            className={inputClasses}
                            {...register('groupName', { required: true })}
                        />
                        {errors.scheduleName && (
                            <p style={{ color: 'red' }}>Schedule Name is required.</p>
                        )}
                    </div>
                    <RowContainer spacing="medium" className="justify-center">
                        <Button type="button" onClick={() => closeForm && closeForm()}>
                            Cancel
                        </Button>
                        <Button type="submit">Create</Button>
                    </RowContainer>
                </form>
            )}
        </Modal>
    );
};

export default NewGroupModal;
